import React from 'react';
import { Alert, Table }  from 'reactstrap';
import * as Icon from 'react-feather';
import { ConfirmModal } from '../../Modals/Confirm';

export function ConfirmDeleteCompanyContactModal(props) {
    return (
        <ConfirmModal 
            isOpen={props.isOpen}
            toggle={props.toggle} 
            handleConfirm={(e) => props.handleConfirm(props.contact, e)}
            title="Delete Company Contact?"
            confirmText="Yes, Delete Compant Contact"
            confirmColor="danger"
            confirmIcon={Icon.Trash2}
        >
            <Alert color="warning">
                <strong>Are you sure you wish to delete the following Company Contact?</strong>
            </Alert>

            <Table bordered>
                <thead>
                    <tr>
                        <th className="col-xs-6">First Name</th>
                        <th className="col-xs-6">Surname</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>{props.contact.firstName}</td>
                        <td>{props.contact.surname}</td>
                    </tr>
                </tbody>
            </Table>
        </ConfirmModal>
    );
}